import React from 'react';
import TourMenuWeb from '../TourMenuWeb/TourMenuWeb.react';
import TourMenuMobile from '../TourMenuMobile/TourMenuMobile.react';
import {PropTypes} from 'prop-types';

class TourMenu extends React.Component {
    static propTypes = {
        tour: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
        mediaMatches: PropTypes.shape({
            screenXsMax: PropTypes.boolean,
        }),
    };

    render() {
        let props = this.props;
        let tourData = props.tour.get('tourData') || null;
        let groups = (tourData !== null ? tourData.groups : null) || null;
        if (groups && groups.length > 1) {
            return props.mediaMatches.screenXsMax ? (
                <TourMenuMobile {...this.props} />
            ) : (
                <TourMenuWeb {...this.props} />
            );
        }

        return null;
    }
}

export default TourMenu;
